import Clipboard from './Clipboard'

export default new Clipboard()